<app-navigation>
  <router-outlet></router-outlet>
</app-navigation>
